function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.25098 15.018C11.8961 15.018 14.851 12.063 14.851 8.41797C14.851 4.77289 11.8961 1.81797 8.25098 1.81797C4.6059 1.81797 1.65098 4.77289 1.65098 8.41797C1.65098 12.063 4.6059 15.018 8.25098 15.018ZM8.25098 16.418C12.6693 16.418 16.251 12.8362 16.251 8.41797C16.251 3.99969 12.6693 0.417969 8.25098 0.417969C3.8327 0.417969 0.250977 3.99969 0.250977 8.41797C0.250977 12.8362 3.8327 16.418 8.25098 16.418Z",
  fill: "#EE0056"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.75098 6.8H6.75098C6.64052 6.8 6.55098 6.88954 6.55098 7V10C6.55098 10.1105 6.64052 10.2 6.75098 10.2H9.75098C9.86143 10.2 9.95098 10.1105 9.95098 10V7C9.95098 6.88954 9.86143 6.8 9.75098 6.8ZM6.75098 5.5C5.92255 5.5 5.25098 6.17157 5.25098 7V10C5.25098 10.8284 5.92255 11.5 6.75098 11.5H9.75098C10.5794 11.5 11.251 10.8284 11.251 10V7C11.251 6.17157 10.5794 5.5 9.75098 5.5H6.75098Z",
  fill: "#EE0056"
});

function SvgStopIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopIcon);
export default __webpack_public_path__ + "static/media/StopIcon.6e654840.svg";
export { ForwardRef as ReactComponent };